import { Transition as TransitionBase } from '@headlessui/react';
import { TransitionEvents } from '@headlessui/react/dist/components/transitions/transition';
import { Props } from '@headlessui/react/dist/types';
import { PropsForFeatures } from '@headlessui/react/dist/utils/render';
import { ElementType, MutableRefObject } from 'react';

const DEFAULT_TRANSITION_CHILD_TAG = 'div' as const;
type NewType = MutableRefObject<HTMLDivElement>;

type TransitionChildRenderPropArg = NewType;
const Features = { None: 0, RenderStrategy: 1, Static: 2 };
const TransitionChildRenderFeatures = Features.RenderStrategy;

export interface TransitionClasses {
  enter?: string | string;
  enterFrom?: string | string;
  enterTo?: string | string;
  entered?: string | string;
  leave?: string | string;
  leaveFrom?: string | string;
  leaveTo?: string | string;
}

export * from './transitions';

type TransitionChildProps<TTag> = Props<TTag, TransitionChildRenderPropArg> &
  PropsForFeatures<typeof TransitionChildRenderFeatures> &
  TransitionClasses &
  TransitionEvents & { appear?: boolean };

function getPropsWithTw(props: TransitionClasses) {
  const newProps = { ...props };
  newProps.enter = props.enter;
  newProps.enterFrom = props.enterFrom;
  newProps.enterTo = props.enterTo;
  newProps.leave = props.leave;
  newProps.leaveFrom = props.leaveFrom;
  newProps.leaveTo = props.leaveTo;

  return newProps;
}

function Transition<
  TTag extends ElementType = typeof DEFAULT_TRANSITION_CHILD_TAG
>(props: TransitionChildProps<TTag> & { show?: boolean; appear?: boolean }) {
  // @ts-ignore
  return <TransitionBase {...getPropsWithTw(props)} />;
}

Transition.Child = function Child<
  TTag extends ElementType = typeof DEFAULT_TRANSITION_CHILD_TAG
>(props: TransitionChildProps<TTag>) {
  // @ts-ignore
  return <TransitionBase.Child {...getPropsWithTw(props)} />;
};
Transition.Root = Transition;

export default Transition;
